import {FC} from "react";
import styled from "@emotion/styled/macro";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {ISubNavLink} from "modules/types";
import {isLoggedIn} from "modules/selectors";
import {breakpoints} from "assets/theme";

const Link = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: "Hind", sans-serif;
	font-weight: 600;
	font-size: 16px;
	line-height: 140%;
	text-transform: uppercase;
	padding: 10px;
	height: 100%;
	transition: all 0.3s;

	&.active,
	&:hover {
		color: ${({theme}) => theme.colorPalette.black};
		background: ${({theme}) => theme.colorPalette.white};
	}
`;

const LinkContainer = styled.div`
	display: none;
	position: relative;

	@media (min-width: ${breakpoints.medium}) {
		display: flex;
	}

	&:hover {
		${Link} {
			color: ${({theme}) => theme.colorPalette.black};
			background: ${({theme}) => theme.colorPalette.white};
		}
	}
`;

interface IExternalSubHeaderLink extends ISubNavLink {
	target?: string;
	rel?: string;
}

export const ExternalSubHeaderLink: FC<IExternalSubHeaderLink> = ({
	title,
	href,
	isPrivate,
	target,
	rel,
}) => {
	const {t} = useTranslation();
	const isLogged = useSelector(isLoggedIn);
	const isHideLink = !isLogged && isPrivate;

	if (isHideLink) {
		return null;
	}

	return (
		<LinkContainer>
			<Link href={href} target={target} rel={rel}>
				{t(title)}
			</Link>
		</LinkContainer>
	);
};
